var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinWojoSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "-2 -2 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3002_12899)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "white",
    stroke: "#002F1B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 10,
    width: 18,
    height: 3.6,
    fill: "url(#pattern0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3002_12899",
    x: -1,
    y: -1,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3002_12899"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3002_12899",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3002_12899",
    transform: "translate(-0.404255 -1.55556) scale(0.00531915 0.0277778)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3002_12899",
    width: 341,
    height: 148,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinWojoSelected);
export default __webpack_public_path__ + "static/media/pin_wojo_selected.3a644140d26ba9e625da84b8e5aa127d.svg";
export { ForwardRef as ReactComponent };